module.exports = __webpack_public_path__ + "static/media/fill-drip.dbbe6379.svg";